function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { AppShell } from '../app-shell';
import LoadingIndicator from '../../components/loading-indicator/loading-indicator';
import { ProcessSelection } from '@codametrix/shared-views';
import { sortCaseRuns } from '../../reducers/cases.reducer';
import { FlexCard, RoundedButton, UniversalFeedback } from '@codametrix/ui-components';
import classnames from 'classnames';
import { Notes } from '@codametrix/shared-views';
import { NotesSidebar } from '../../views/notes-sidebar/notes-sidebar';
import { isValidTargetOrigin } from '../../views/utils/common-utils';
const OMITTED_CATEGORIES = new Set([
    ''
]);
var _React_Component;
class CaseDocumentsApp extends (_React_Component = React.Component) {
    componentDidMount() {
        const url = new URL(window.location.toString());
        const args = {
            caseId: url.searchParams.get('caseId'),
            processId: url.searchParams.get('processInstanceId')
        };
        this.props.getORUs(args);
    }
    onDocumentSelect(docMetadata) {
        this.props.onSelect(docMetadata);
    }
    _handleDismissFeedback() {
        this.props.dismissFeedback(true);
    }
    _handleProcessIdChange(event) {
        event.preventDefault();
        const target = event.target || document.createElement('div');
        const linkable = target?.closest('a');
        if (!linkable) return;
        const item = linkable.attributes.getNamedItem('data-process-id');
        if (!item) return;
        const processId = parseInt(item.value);
        if (!processId) return;
        if (processId === this.props.activeCaseRun.process_instance_id) return;
        const caseRuns = this.props.activeCase?.caseRuns;
        if (!caseRuns) return;
        const soughtRun = caseRuns.find((caseRun)=>caseRun.process_instance_id === processId);
        if (!soughtRun) return;
        this.props.setActiveProcess(soughtRun);
    }
    render() {
        const { props } = this;
        const { activeCase, activeCaseRun, locked, loading, activeNotes, documentMetadata, feedback } = props;
        const caseRuns = activeCase?.caseRuns ? sortCaseRuns(activeCase, {}) : {};
        const [activeNote] = activeNotes;
        const docs = documentMetadata.filter((doc)=>!OMITTED_CATEGORIES.has(doc.documentCategory));
        const handleDownload = (event)=>{
            event.preventDefault();
            const targetOrgin = window.location.origin;
            // validate Target Origin
            if (isValidTargetOrigin(targetOrgin)) {
                var link = document.createElement('a');
                link.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(activeNote.content));
                link.setAttribute('download', `${activeNote.filename ?? 'note.txt'}`);
                link.style.visibility = 'hidden';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        };
        const styleClasses = [
            'centered-application',
            'case-documents-view'
        ];
        let inner;
        let header;
        if (locked) {
            styleClasses.push(`cmx-application-locked`);
        }
        if (loading) {
            styleClasses.push(`cmx-application-masked`, `cmx-application-loading`, 'loading-view');
            inner = /*#__PURE__*/ _jsx(LoadingIndicator, {
                text: `Loading Documents...`
            });
        } else if (activeNote !== undefined) {
            styleClasses.push(`cmx-application-loaded`);
            header = /*#__PURE__*/ _jsxs("div", {
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "case-docs-header cols",
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: "case-docs-header-left",
                                children: /*#__PURE__*/ _jsxs("h5", {
                                    children: [
                                        "Documents for process instance:",
                                        ' ',
                                        activeCaseRun.process_instance_id
                                    ]
                                })
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "case-docs-header-right case-docs-header-buttons",
                                children: [
                                    /*#__PURE__*/ _jsx(RoundedButton, {
                                        className: "btn-primary btn-sm active download-btn btn",
                                        type: "submit",
                                        title: "Download Selected Document",
                                        onClick: handleDownload,
                                        children: "Download"
                                    }),
                                    /*#__PURE__*/ _jsx(ProcessSelection, {
                                        caseRuns: caseRuns,
                                        activeId: activeCaseRun.process_instance_id,
                                        onClick: this._handleProcessIdChange
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "created-on",
                        children: /*#__PURE__*/ _jsxs("h6", {
                            children: [
                                "Created on ",
                                activeCaseRun.datetime_of_service
                            ]
                        })
                    })
                ]
            });
            inner = /*#__PURE__*/ _jsx(FlexCard, {
                header: header,
                className: "case-documents-card oru",
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "notes-view",
                    children: [
                        !!docs?.length && /*#__PURE__*/ _jsx("div", {
                            className: "doc-side-nav",
                            children: /*#__PURE__*/ _jsx(NotesSidebar, {
                                onSelect: this.onDocumentSelect,
                                activeNote: activeNote,
                                documentMetadata: docs
                            })
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "notes-content",
                            children: /*#__PURE__*/ _jsx(Notes, {
                                notes: [
                                    activeNote
                                ]
                            })
                        })
                    ]
                })
            });
        } else {
            styleClasses.push(`cmx-application-loaded`);
            header = /*#__PURE__*/ _jsx("div", {
                className: "case-docs-header cols",
                children: /*#__PURE__*/ _jsx(ProcessSelection, {
                    caseRuns: caseRuns,
                    activeId: activeCaseRun.process_instance_id,
                    onClick: this._handleProcessIdChange
                })
            });
            inner = /*#__PURE__*/ _jsxs(FlexCard, {
                header: header,
                className: "case-documents-card no-notes",
                children: [
                    /*#__PURE__*/ _jsx("br", {}),
                    /*#__PURE__*/ _jsx("h5", {
                        children: "Document not available"
                    })
                ]
            });
        }
        return /*#__PURE__*/ _jsx(AppShell, {
            registerActivity: props.registerActivity,
            className: "case-documents-app",
            children: /*#__PURE__*/ _jsxs("div", {
                className: classnames(styleClasses),
                children: [
                    locked && /*#__PURE__*/ _jsx("div", {
                        className: "locked-message",
                        children: "The case details you were viewing are no longer active."
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "centered-application-wrapper",
                        children: [
                            feedback && /*#__PURE__*/ _jsx(UniversalFeedback, {
                                dismissFeedback: this._handleDismissFeedback,
                                feedback: feedback,
                                showFeedback: feedback ? true : false
                            }),
                            inner
                        ]
                    })
                ]
            })
        });
    }
    constructor(props){
        super(props);
        this._handleProcessIdChange = this._handleProcessIdChange.bind(this);
        this._handleDismissFeedback = this._handleDismissFeedback.bind(this);
        this.onDocumentSelect = this.onDocumentSelect.bind(this);
    }
}
_define_property(CaseDocumentsApp, "defaultProps", {
    loading: false,
    dismissFeedback: (message)=>{}
});
export { CaseDocumentsApp as default };
